<template>
    <base-table :key="tick" class="table align-items-center table-flush"
                tbody-classes="list"
                :data="usercustomers">
        <template slot="columns">
            <th>Zugriff auf folgende Organisationen</th> <!---- todo tooltip für operatoren beachten ---->
            <th class="text-right">
                <base-dropdown position="right" v-if="!isLoading">
                    <base-button slot="title" icon="ni ni-fat-add" size="sm" class="dropdown-toggle"></base-button>
                    <a v-for="cus in customers" :key="'cus'+cus.id" class="dropdown-item align-right" href="#" @click="addCusUser(cus['@id'],uid)">{{cus.name}} hinzufügen</a>
                </base-dropdown>
            </th>
        </template>
        <template slot-scope="{row,index}">
            <th v-if="isLoading" scope="row" >
                <div class="loading"> </div>
            </th>
            <th v-else scope="row" v-html="row.customer.name">
            </th>
            <td>
                <div v-if="isLoading" class="loading-button"> </div><div v-else>
                <base-button v-if="!row.delete" type="primary" icon="far fa-trash-alt" size="sm" v-on:click="deleteConfirmation(index)"></base-button>
                <div v-if="row.delete" style="margin-top: 1rem;"><span  class="text-danger">Sicher? <i class="far fa-trash-alt"></i></span><br>
                    <base-button v-if="row.delete" size="sm" type="danger" icon="fas fa-check" v-on:click="deleteUserCustomer(row.id)">Ja</base-button>
                    <base-button v-if="row.delete" size="sm" type="info" icon="fas fa-times" v-on:click="deleteConfirmation(index)">Nein</base-button>
                </div>
            </div>
            </td>
        </template>
    </base-table>
</template>

<script>
    export default {
        name:"UserCustomers",
        props: {
            uid: {
                type: String,
            },
            customer: {
                type: String,
            }
        },
        data() {
            return {
                usercustomers: [],
                isLoading: true,
                tick: 21321
            }
        },
        created() {
            this.init();

        },
        computed: {
            customers() {
                return (this.$store.getters['customer/isReady']) ? this.$store.getters['customer/showCustomerCollection'] : [];
            }
        },
        methods: {
            init() {
                this.getUserCustomers(this.uid).then(data =>{
                    this.usercustomers = data.member;
                    this.isLoading = false;
                    this.tick++;
                })
                    .catch(err => {
                        this.$store.dispatch('alert/error',err);
                        this.isLoading = false;
                        this.tick++;
                    })
            },
            getUserCustomers(id) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/users/`+id+`/user_customers?pagination=false`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve({
                                    totalItems: response['hydra:totalItems'],
                                    member: response['hydra:member']
                                });
                            },
                            error => {
                                reject(error);
                            });
                });
            },
            addCusUser(lid,uid) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = {
                        user: '/api/users/'+uid,
                        customer: lid
                    };
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/user_customers`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                                this.$store.dispatch('alert/success','Organisation hinzugefügt.');
                                this.getUserCustomers(uid).then(response => {
                                    this.usercustomers = response.member;
                                    this.isLoading = false;
                                    this.tick++;
                                });
                            },
                            error => {
                                reject(error);
                                this.$store.dispatch('alert/error',error);
                                this.isLoading = false;
                                this.tick++;
                            });
                });
            },
            deleteUserCustomer(id) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'DELETE',
                        headers: header,
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/user_customers/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                                this.getUserCustomers(this.uid).then(response => {
                                    this.usercustomers = response.member;
                                    this.$store.dispatch('alert/success','Rechte für Organisation gelöscht.');
                                    this.isLoading = false;
                                    this.tick++;
                                });

                            },
                            error => {
                                reject(error);
                                this.isLoading = false;
                                this.$store.dispatch('alert/error',error);
                                this.tick++;
                            });
                });
            },
            deleteConfirmation(index) {
                if(typeof this.usercustomers[index].delete === "undefined") {
                    this.usercustomers[index].delete = false;
                }
                this.usercustomers[index].delete = !this.usercustomers[index].delete;
                this.tick++;
            },
        }
    }
</script>

<style scoped>

</style>